import { useLingui } from "@lingui/react/macro";
import { AccessibleIcon } from "@offstreetparking/design-system/accessibility";
import { LinkButton } from "@offstreetparking/design-system/forms";
import { ChevronRightIcon } from "@offstreetparking/design-system/icons/ChevronRightIcon";
import { classNames } from "@offstreetparking/design-system/utils";
import { useState } from "react";
import { ParkingLocationsRow } from "./ParkingLocationsRow";
type ParkingLocationsProps = {
	locations: {
		lot?: {
			centerLat?: string;
			centerLng?: string;
			addressLineOne?: string;
			addressLineTwo?: string;
			city?: string;
			state?: string;
			country?: string;
			postalCode?: string;
			useAddress?: boolean;
			name: string;
		};
		name: string;
		order: number;
	}[];
	showDirectionsLink?: boolean;
};
export const ParkingLocations = ({ locations, showDirectionsLink = true }: ParkingLocationsProps) => {
	const { t } = useLingui();
	const [showAllLocations, setShowAllLocations] = useState(false);
	const orderedLocations = locations.sort((a, b) => a.order - b.order);
	const topLocations = orderedLocations.slice(0, 3);
	const otherLocations = orderedLocations.slice(3);
	return (
		<div className="mt-4 space-y-4 p-4">
			{topLocations.map(({ lot, name }) => (
				<div key={name} className="rounded-md bg-neutral-faded p-4 [print-color-adjust:exact]">
					<ParkingLocationsRow lot={lot} name={name} showDirectionsLink={showDirectionsLink} />
				</div>
			))}
			{otherLocations.length > 0 && (
				<>
					<div>
						<LinkButton
							size="sm"
							type="button"
							className="flex items-center gap-2"
							onClick={() => setShowAllLocations(!showAllLocations)}
						>
							{showAllLocations ? t`Hide additional locations` : t`Show more locations`}
							<AccessibleIcon>
								<ChevronRightIcon
									className={classNames(
										"h-4 w-4 transition-all",
										showAllLocations ? "rotate-90" : "",
									)}
								/>
							</AccessibleIcon>
						</LinkButton>
					</div>
					{showAllLocations &&
						otherLocations.map(({ lot, name }) => (
							<div key={name} className="rounded-md bg-neutral-faded p-4 [print-color-adjust:exact]">
								<ParkingLocationsRow lot={lot} name={name} showDirectionsLink={showDirectionsLink} />
							</div>
						))}
				</>
			)}
		</div>
	);
};
